import { ForwardedRef, forwardRef, memo } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';

interface SwitchFieldProps extends SwitchProps {
  label?: string;
}

function SwitchField(props: SwitchFieldProps, ref: ForwardedRef<HTMLButtonElement>) {
  const { disabled: isDisabled, label, color = 'primary' } = props;

  return (
    <FormControlLabel control={<Switch ref={ref} {...props} color={color} />} disabled={isDisabled} label={label} />
  );
}

export default memo(forwardRef(SwitchField));
